import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class BackButton extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {/* <Link to={props.location.state.from}>Back</Link>; */}
      </div>
    );
  }
}

export default BackButton;
